package com.macrofocus.eflux

import com.macrofocus.common.selection.MutableSelection
import com.macrofocus.common.selection.MutableSingleSelection
import com.macrofocus.common.selection.Selection
import com.macrofocus.common.selection.SingleSelection
import com.macrofocus.eflux.network.coordinate.Coordinate
import com.macrofocus.eflux.network.logical.LogicalBranchId
import com.macrofocus.eflux.network.logical.LogicalBusId
import com.macrofocus.eflux.network.risk.RiskComponent
import com.macrofocus.eflux.network.schema.Schema

class SingleEFluxController(configuration: EFluxConfiguration) : AbstractEFluxController(configuration) {
    override val logicalBusProbing: SingleSelection<LogicalBusId>
        get() = primaryLogicalBusProbing
    override val logicalBranchProbing: SingleSelection<LogicalBranchId>
        get() = primaryLogicalBranchProbing
    override val riskComponentProbing: SingleSelection<RiskComponent>
        get() = primaryRiskComponentProbing
    override val coordinateProbing: SingleSelection<Coordinate>
        get() = primaryCoordinateProbing
    override val schemaProbing: SingleSelection<Schema>
        get() = primarySchemaProbing
    override val logicalBusSelection: Selection<LogicalBusId>
        get() = primaryLogicalBusSelection
    override val logicalBranchSelection: Selection<LogicalBranchId>
        get() = primaryLogicalBranchSelection
    override val riskComponentSelection: Selection<RiskComponent>
        get() = primaryRiskComponentSelection
    override val coordinateSelection: Selection<Coordinate>
        get() = primaryCoordinateSelection
    override val schemaSelection: Selection<Schema>
        get() = primarySchemaSelection
    override val secondaryLogicalBusProbing: MutableSingleSelection<LogicalBusId>
        get() = primaryLogicalBusProbing
    override val secondaryLogicalBranchProbing: MutableSingleSelection<LogicalBranchId>
        get() = primaryLogicalBranchProbing
    override val secondaryRiskComponentProbing: MutableSingleSelection<RiskComponent>
        get() = primaryRiskComponentProbing
    override val secondaryCoordinateProbing: MutableSingleSelection<Coordinate>
        get() = primaryCoordinateProbing
    override val secondarySchemaProbing: MutableSingleSelection<Schema>
        get() = primarySchemaProbing
    override val secondaryLogicalBusSelection: MutableSelection<LogicalBusId>
        get() = primaryLogicalBusSelection
    override val secondaryLogicalBranchSelection: MutableSelection<LogicalBranchId>
        get() = primaryLogicalBranchSelection
    override val secondaryRiskComponentSelection: MutableSelection<RiskComponent>
        get() = primaryRiskComponentSelection
    override val secondaryCoordinateSelection: MutableSelection<Coordinate>
        get() = primaryCoordinateSelection
    override val secondarySchemaSelection: MutableSelection<Schema>
        get() = primarySchemaSelection

    init {
        primaryLogicalBusProbing.addSingleSelectionListener { event ->
            val probing = primaryProbing
            probing.selected = event.currentSelection
        }
        primaryLogicalBranchProbing.addSingleSelectionListener { event ->
            val probing = primaryProbing
            probing.selected = event.currentSelection
        }
        primaryRiskComponentProbing.addSingleSelectionListener { event ->
            val probing = primaryProbing
            probing.selected = event.currentSelection
        }
        primaryCoordinateProbing.addSingleSelectionListener { event ->
            val probing = primaryProbing
            probing.selected = event.currentSelection
        }
        primarySchemaProbing.addSingleSelectionListener { event ->
            val probing = primaryProbing
            probing.selected = event.currentSelection
        }

        primaryLogicalBusSelection.addSelectionListener { event ->
            primarySelection.selected = event.selected.firstOrNull()
        }
        primaryLogicalBranchSelection.addSelectionListener { event ->
            primarySelection.selected = event.selected.firstOrNull()
        }
        primaryRiskComponentSelection.addSelectionListener { event ->
            primarySelection.selected = event.selected.firstOrNull()
        }
        primaryCoordinateSelection.addSelectionListener { event ->
            primarySelection.selected = event.selected.firstOrNull()
        }
        primarySchemaSelection.addSelectionListener { event ->
            primarySelection.selected = event.selected.firstOrNull()
        }
    }

    override fun top(probed: Any?, selected: Any?): Any? {
        return if(probed != null) probed else if(selected != null) selected else null
    }

    override fun extra(probed: Any?, selected: Any?): Any? {
        if(selected != null) {
            return selected
        } else {
            return null
        }
    }

    override val overlayProbing: Boolean = true

    override fun probeSubstation(logicalBusId: LogicalBusId?, primary: Boolean) {
        if(logicalBusId != null) {
            primaryLogicalBranchProbing.clearSelection()
            primaryCoordinateProbing.clearSelection()
        }
        val selection = if(primary) primaryLogicalBusProbing else primaryLogicalBusProbing
        if(logicalBusId != null) {
            selection.setSelectedElement(logicalBusId)
        } else {
            selection.clearSelection()
        }
    }

    override fun probeLine(logicalBranchId: LogicalBranchId?, primary: Boolean) {
        if(logicalBranchId != null) {
            primaryLogicalBusProbing.clearSelection()
            primaryCoordinateProbing.clearSelection()
        }
        val selection = if(primary) primaryLogicalBranchProbing else primaryLogicalBranchProbing
        if(logicalBranchId != null) {
            selection.setSelectedElement(logicalBranchId)
        } else {
            selection.clearSelection()
        }
    }

    override fun probeCoordinate(coordinate: Coordinate?, primary: Boolean) {
        if(coordinate != null) {
            primaryLogicalBusProbing.clearSelection()
            primaryLogicalBranchProbing.clearSelection()
        }
        val selection = if(primary) primaryCoordinateProbing else primaryCoordinateProbing
        if(coordinate != null) {
            selection.setSelectedElement(coordinate)
        } else {
            selection.clearSelection()
        }
    }

    override fun selectSubstation(logicalBusId: LogicalBusId?, primary: Boolean) {
        primaryLogicalBranchSelection.clearSelection()
        primaryCoordinateSelection.clearSelection()
        val selection = if(primary) primaryLogicalBusSelection else primaryLogicalBusSelection
        if(logicalBusId != null) {
            selection.setSelectedElement(logicalBusId)
        } else {
            selection.clearSelection()
        }
    }

    override fun selectLine(logicalBranchId: LogicalBranchId?, primary: Boolean) {
        primaryLogicalBusSelection.clearSelection()
        primaryCoordinateSelection.clearSelection()
        val selection = if(primary) primaryLogicalBranchSelection else primaryLogicalBranchSelection
        if(logicalBranchId != null) {
            selection.setSelectedElement(logicalBranchId)
        } else {
            selection.clearSelection()
        }
    }

    override fun selectCoordinate(coordinate: Coordinate?, primary: Boolean) {
        primaryLogicalBusSelection.clearSelection()
        primaryLogicalBranchSelection.clearSelection()
        val selection = if(primary) primaryCoordinateSelection else primaryCoordinateSelection
        if(coordinate != null) {
            selection.setSelectedElement(coordinate)
        } else {
            selection.clearSelection()
        }
    }
}
